/**
 * Publishes a sub-viewport's texture, for `ViewportTexture` consumers, and its pass,
 * for the orchestrator, as one act: neither can exist without the other. It derives
 * `dependsOn` from the parsed tree itself, which the registry contexts do not read.
 */
import { useCallback, useEffect, useMemo } from 'react';
import { useRegisterViewportPass } from '../../../r3f/contexts/ViewportPassRegistryContext.js';
import { usePublishViewportTexture, } from '../../../r3f/contexts/ViewportTextureContext.js';
import { collectNestedViewportPaths } from './nestedViewportPaths.js';
import { useTargetViews } from './targetViews.js';
export function usePublishViewportPass({ path, node, target, width, height, isTransparent, render, }) {
    const registerViewportPass = useRegisterViewportPass();
    const views = useTargetViews(target, isTransparent);
    const entry = useMemo(() => ({ plain: views.plain, decoding: views.decoding, size: { x: width, y: height } }), [views, width, height]);
    usePublishViewportTexture(path, entry);
    const dependsOn = useMemo(() => collectNestedViewportPaths(node, path), [node, path]);
    const renderViews = useCallback(() => {
        render();
        views.fill();
    }, [render, views]);
    useEffect(() => registerViewportPass(path, { dependsOn, render: renderViews }), [registerViewportPass, path, dependsOn, renderViews]);
}
//# sourceMappingURL=usePublishViewportPass.js.map